import axiosInstance from "./axiosInstance";

const filterService = {
  getAllFilters: async () => {
    try {
      const response = await axiosInstance.get("/filters/allActive");
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
};

export default filterService;
